import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL } from "../../config";

const BASES_URL = `${BASE_URL}/api`;

export const fetchAvailableFiles = async (setAvailableFiles) => {
    try {
        const response = await axios.get(`${BASES_URL}/list-files`);
        if (response.data && response.data.files) {
            setAvailableFiles(Object.values(response.data.files));
        } else {
            setAvailableFiles([]);
        }
    } catch (error) {
        console.error("Greška pri učitavanju dostupnih fajlova:", error);
        toast.error("Greška pri učitavanju fajlova.");
        setAvailableFiles([]);
    }
};

export const handleUpload = async (file, setOverlay, setFile) => {
    if (!file) {
        toast.warn("Molimo izaberite fajl!");
        return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
        setOverlay({ active: true, message: "Učitavanje fajla..." });
        const response = await axios.post(`${BASES_URL}/upload`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });

        if (response.status === 200) {
            toast.success(`Fajl "${file.name}" je uspješno učitan!`);
            setFile("");
        }
    } catch (error) {
        console.error("Greška prilikom slanja fajla:", error);
        toast.error("Došlo je do greške prilikom učitavanja fajla.");
    } finally {
        setOverlay({ active: false, message: "" });
    }
};

export const handleParse = async (selectedFile, setOverlay, setSelectedFile) => {
    if (!selectedFile) {
        toast.warn("Molimo izaberite fajl!");
        return;
    }

    try {
        setOverlay({ active: true, message: "Parsiranje fajla..." });

        const response = await axios.post(`${BASES_URL}/parse`, {
            fileName: selectedFile,
        });

        if (response.status === 200) {
            toast.success(`Fajl "${selectedFile}" je uspješno parsiran!`);
            setSelectedFile("");
        }
    } catch (error) {
        console.error("Greška prilikom pokretanja parsera:", error);
        toast.error("Došlo je do greške prilikom parsiranja.");
    } finally {
        setOverlay({ active: false, message: "" });
    }
};
